import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import RoleAccessLayer from "../../../components/crm/RoleAccessLayer";

const RoleAccess = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Role Access' />

                {/* BlankPageLayer */}
                <RoleAccessLayer />
            </MasterLayout>
        </>
    );
};

export default RoleAccess;